export default {
  en: {
    singular: "AI Queue",
    plural: "AI Queue",

    tabs: {
      general: "General",
    },

    blocks: {
      status: "Status",
      file_info: "File Info",
      timestamps: "Timestamps",
    },

    fields: {
      original_filename: "File Name",
      queue_state: "Status",
      queue_step: "Step",
      priority: "Priority",
      confirmed_model_type: "Model Type",
      mime_type: "MIME Type",
      file_size: "File Size",
      retry_count: "Retries",
      max_retries: "Max Retries",
      started_at: "Started At",
      completed_at: "Completed At",
      failed_at: "Failed At",
      created_at: "Created At",
    },

    badges: {
      // queue_state
      pending: "Pending",
      processing: "Processing",
      failed: "Failed",
      cancelled: "Cancelled",
      awaiting_user_action: "Awaiting Action",
      completed: "Completed",

      // priority
      high: "High",
      normal: "Normal",
      low: "Low",

      // queue_step
      awaiting_ai_classification: "AI Classification",
      awaiting_model_confirmation: "Model Confirmation",
      awaiting_extraction: "Extraction",
      awaiting_ai_review: "AI Review",
      awaiting_user_review: "User Review",
      awaiting_finalization: "Ready to Finalize",
    },

    filters: {
      queue_state: "Status",
      priority: "Priority",
    },

    options: {
      queue_state: {
        pending: "Pending",
        processing: "Processing",
        failed: "Failed",
        cancelled: "Cancelled",
        awaiting_user_action: "Awaiting Action",
        completed: "Completed",
      },
      priority: {
        high: "High",
        normal: "Normal",
        low: "Low",
      },
    },
  },

  fr: {
    singular: "File d'attente IA",
    plural: "File d'attente IA",

    tabs: {
      general: "Général",
    },

    blocks: {
      status: "Statut",
      file_info: "Informations du fichier",
      timestamps: "Dates",
    },

    fields: {
      original_filename: "Nom du fichier",
      queue_state: "Statut",
      queue_step: "Étape",
      priority: "Priorité",
      confirmed_model_type: "Type de modèle",
      mime_type: "Type MIME",
      file_size: "Taille du fichier",
      retry_count: "Tentatives",
      max_retries: "Tentatives max.",
      started_at: "Démarré le",
      completed_at: "Complété le",
      failed_at: "Échoué le",
      created_at: "Créé le",
    },

    badges: {
      // queue_state
      pending: "En attente",
      processing: "En traitement",
      failed: "Échoué",
      cancelled: "Annulé",
      awaiting_user_action: "Action requise",
      completed: "Complété",

      // priority
      high: "Haute",
      normal: "Normale",
      low: "Basse",

      // queue_step
      awaiting_ai_classification: "Classification IA",
      awaiting_model_confirmation: "Confirmation du modèle",
      awaiting_extraction: "Extraction",
      awaiting_ai_review: "Révision IA",
      awaiting_user_review: "Révision utilisateur",
      awaiting_finalization: "Prêt à finaliser",
    },

    filters: {
      queue_state: "Statut",
      priority: "Priorité",
    },

    options: {
      queue_state: {
        pending: "En attente",
        processing: "En traitement",
        failed: "Échoué",
        cancelled: "Annulé",
        awaiting_user_action: "Action requise",
        completed: "Complété",
      },
      priority: {
        high: "Haute",
        normal: "Normale",
        low: "Basse",
      },
    },
  },
};
